export default [
  {
    path: "/user-profile",
    component: () => import("./moduleLayout.vue"),
    children: [
      {
        path: "profile",
        name: "profile",
        props: true,
        component: () => import("./pages/profile/index.vue"),
        meta: {
          pageTitle: "",
          slug: "personal-profile",
          breadcrumb: [
            {
              text: "الملف الشخصي",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
